<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="UserId"
      ref="list"
      unit="销售出库单"
      :page="page"
      :show-query="true"
      :get-data-func="api.list"
      @row-select="rowSelect"
      v-if="trendShow"
      urlHash="business/stock/selloutwarehouse"
      :temp-params="tempParams"
      :show-checkbox="showCheckbox"
      :queryParamsAppend="queryParamsAppend"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="业务类型" label-width="85px">
          <el-select
            v-model="queryParamsAppend.BusinessTypeId"
            clearable
            :disabled="isSelect"
          >
            <el-option
              v-for="item in businessTypeList"
              :key="item.BusinessTypeId"
              :label="item.BusinessType"
              :value="item.BusinessTypeId"
            ></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
    <!-- 明细 -->
    <el-button
      v-if="show"
      type="primary"
      @click="onCustomTable"
      icon="el-icon-s-tools"
      style="margin: 30px 0 10px 10px"
    >
      明细项
    </el-button>
    <el-table
      ref="multipleTable"
      :row-key="(row) => row.Prop"
      :data="tableData"
      v-if="show"
      @selection-change="handleSelectionChange"
      stripe
      border
    >
      <el-table-column type="selection" v-if="is_listDialog" width="55">
      </el-table-column>
      <template v-for="(item, index) in tableColumns">
        <!-- 需判断是否有价格的权限  -->
        <template v-if="item.IsShow">
          <el-table-column
            :resizable="false"
            :key="`${item.Prop}-${index}`"
            :prop="item.Prop"
            v-if="shouldShowColumn(item)"
            :label="item.Label"
            :align="item.Align ?? 'left'"
            :min-width="item.Width"
            show-overflow-tooltip
          >
            <template slot-scope="{ row }">
              <span v-if="isNumericProperty(item.Prop)">
                {{ $commonJs.toThousands(row[item.Prop]) }}
              </span>
              <span v-else>
                {{ row[item.Prop] }}
              </span>
            </template>
          </el-table-column>
        </template>
      </template>
    </el-table>
    <customTableDialog
      ref="customTableDialog"
      @onSave="onSave"
      :initTableData="tableColumns"
      tableType="销售出库单明细"
    />

    <!-- <el-table @selection-change="handleSelectionChange" border class="table_bottom table-line tb-c-head"
      :data="tableData" style="margin-top: 18px;">
      <el-table-column type="selection" v-if="is_listDialog" width="55"> </el-table-column>
      <el-table-column prop="SourceNo" label="来源单号" min-width="100" align="left"></el-table-column>
      <el-table-column prop="ProductNo" label="存货编码" min-width="100" align="left"></el-table-column>
      <el-table-column prop="ProductName" label="存货名称" min-width="100" align="left"></el-table-column>
      <el-table-column prop="ProductSpec" label="规格" min-width="100" align="left"></el-table-column>
      <el-table-column prop="ColorName" label="颜色" min-width="100" align="left"></el-table-column>
      <el-table-column prop="PropertyName" label="属性" min-width="100" align="left"></el-table-column>
      <el-table-column prop="UnitName" label="计量单位" min-width="100" align="left"></el-table-column>
      <el-table-column prop="Quantity" label="数量" min-width="100" align="right">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.Quantity) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Price" label="单价" min-width="100" align="right" v-if="canPrice"></el-table-column>
      <el-table-column prop="Amount" label="金额" min-width="100" align="right" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.Amount) }}</span>
        </template>
      </el-table-column>
    </el-table> -->
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
import customTableDialog from "@/components/common/customTableDialog/customTableDialog";

export default {
  mixins: [listMixin],
  components: { list, customTableDialog },
  provide() {
    return {
      IsDefaultMonth: false,
    };
  },
  props: {
    is_listDialog: {
      type: Boolean,
      default: false,
    },
    isSelect: {
      type: Boolean,
      default: false,
    },
    // canPrice: {
    //   type: Boolean,
    //   default: true,
    // },
  },
  data() {
    return {
      api: require("@/api/stock/stOutDoc").default,
      sourceTypeApi: require("@/api/ba/sourceType").default,
      businessTypeApi: require("@/api/ba/businessType").default,
      FieldSettingApi: require("@/api/sy/fieldSetting").default,
      trendShow: true,
      OrderNo: "",
      tableData: [],
      queryParamsAppend: {
        BusinessTypeId: null,
      },
      tempParams: {
        OutType: 17,
      },
      subSelectList: [],
      businessTypeList: [],
      tableColumns: [],
      show: false,
    };
  },
  computed: {
    canPrice() {
      return this.$permission.canPrice("/business/stock/selloutwarehouse");
    },
  },
  activated() {
    this.getRouterInfo();
  },
  mounted() {
    this.getBusinessType();
    this.getTableColumns();
  },
  methods: {
    /** 价格权限的字段 */
    shouldShowColumn(item) {
      if (!item.IsShow) return false;
      const priceProps = [
        "PurchasePrice",
        "SalePrice",
        "RetailPrice",
        "QuotedPrice",
        "Discount",
        "TaxRate",
        "Price",
        "TaxPrice",
        "Amount",
        "TaxLimit",
        "TaxAmount",
        "DiscountAmount",
        "Rate",
        "Price",
      ];
      return (
        (this.canPrice && priceProps.includes(item.Prop)) ||
        !priceProps.includes(item.Prop)
      );
    },
    /** 千位符格式化数字类型 */
    isNumericProperty(prop) {
      return ["PuQuantity", "Amount", "TaxAmount"].includes(prop);
    },
    async getTableColumns() {
      const res = await this.FieldSettingApi.list({ Type: "销售出库单明细" });
      this.tableColumns = [];
      this.tableColumns = res.Data;
    },
    onCustomTable() {
      this.$refs.customTableDialog.dialogVisible = true;
    },
    onSave() {
      this.getTableColumns();
      this.$message.success("保存成功");
    },
    getBusinessType() {
      this.sourceTypeApi.list({}).then((res) => {
        if (res.Code == 0) {
          this.SourceTypeIdArr = res.Data;
          let params = "销售出库单";
          let index = this.SourceTypeIdArr.findIndex(
            (item) => item.SourceType == params
          );
          let SourceTypeId = this.SourceTypeIdArr[index].SourceTypeId;
          this.businessTypeApi
            .getSourceTypeToBusinessType(SourceTypeId)
            .then((res) => {
              if (res.Code == 0) {
                this.businessTypeList = res.Data;
              }
            });
        }
      });
    },
    getRouterInfo() {
      if (this.$router.history.current.params) {
        this.tempParams.Ids = {
          paramValueType: "resetParamValue",
          isReset: true,
          value: this.$router.history.current.params.Ids,
        };

        this.tempParams.SourceType = {
          paramValueType: "resetParamValue",
          isReset: true,
          value: this.$router.history.current.params.SourceType,
        };
        this.tempParams.SourceDocId = {
          paramValueType: "resetParamValue",
          isReset: true,
          value: this.$router.history.current.params.SourceDocId,
        };
        this.tempParams.SourceIds = {
          paramValueType: "resetParamValue",
          isReset: true,
          value: this.$router.history.current.params.SourceIds,
        };
        this.tempParams.SaOrderNo = {
          paramValueType: "resetParamValue",
          isReset: true,
          value: this.$router.history.current.params.SaOrderNo,
        };
        this.$refs.list.getData();
      }
      // else{
      //   this.sourceTypeApi.info("销售出库单").then(res=> {
      //     this.tempParams.OutType=res.SourceTypeId
      //   });
      // }
    },
    rowSelect(row) {
      this.show = true;
      let id = row.DocId;
      this.api.info(id).then((res) => {
        this.OrderNo = res.Data.DocNo;
        if (this.isSelect) {
          res.Data.Products.forEach((item) => {
            item.Quantity = item.Quantity - (item.SaDocOccupyQuantity ?? 0);
            item.Amount = item.Quantity * item.Price;
            item.TradeUnitId = res.Data.TradeUnitId;
            item.TradeUnitName = res.Data.TradeUnitName;
          });
          let tList = res.Data.Products;
          console.log("tList", tList);
          this.tableData = tList;
        } else {
          this.tableData = res.Data.Products;
        }
      });
    },
    handleSelectionChange(data) {
      this.subSelectList = data;
      console.log("this.subSelectList ", this.subSelectList);
    },
  },
};
</script>
